import React, {Fragment, useEffect, useRef, useState} from 'react';
import {
    Button,
    Col,
    Container,
    FormGroup,
    Label,
    Media,
    Row,
    Input
} from 'reactstrap';

import localized from "../../i18n";
import {Formik} from "formik";
import Field from "../Field";
import {emailvalidate, matchesPassword, required, strongPassword} from "../Field/validate";
import axios from "axios";
import {handleError} from "../HandleError";
import toast from "react-hot-toast";
import {Link, useNavigate} from "react-router-dom";
import cookie from "../../utils/cookie";
import ReCAPTCHA from "react-google-recaptcha";
import {getParams} from "../../utils/params";

const SignUp = () => {
    const navigate = useNavigate();
    const [captcha,setCaptcha] = useState("")
    const [togglePassword, setTogglePassword] = useState(false);
    const [toggleCPassword, setCTogglePassword] = useState(false);
    const [language, setLanguage] = useState(localStorage.getItem("lang")??"en");
    const recaptchaRef = useRef(null);
    const localLanguage = getParams("lang") && getParams("lang")==="fr" ? "fr":"en"

    useEffect(() => {
        if(getParams("lang")) {
            setLanguage(getParams("lang"))
        } else {
            setLanguage("en");
        }
    },[]);

    const changeLanguage = (event) => {
        setLanguage(event.target.value);
        const language = event.target.value || "en";
        localized.setLanguage(language);
        localStorage.setItem('lang',language);
        localized.setLanguage(event.target.value || "en")
        navigate('/signup?lang='+language);
    }
   const getPartneroId = () =>{
        var name ='partnero_partner=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }
    const signup = (values, setSubmitting) => {
        const token = recaptchaRef.current.getValue();
        setSubmitting(true);
        const data = {...values,language:language,"g-recaptcha-response":token,partner_key:getPartneroId()};
        console.log(data);
        axios.post("/api/register",data)
            .then((response) => {
                setSubmitting(false);
                cookie.save('credentials', response.data.data.email, {
                    path: '/',
                    days: 1,
                });
                if(response.data.data.verified === true) {
                    navigate("/login");
                } else {
                    navigate("/verify-otp");
                }
                toast(localized.registered_successfully, {
                    icon: '  ✅',
                    style: {borderRadius: '10px', background: '#333', color: '#fff' },
                });
            }).catch((err) => {
                recaptchaRef.current.reset();
                setCaptcha("");
                setSubmitting(false);
                handleError(err);
        })
    }

    return (
        <Container fluid={true} className="p-0">
            <Row className="m-0">
                <Col xs='12' className="p-0">
                    <div className='login-card'>
                        <Fragment>
                            <div>
                                <div className='logo'>
                                    <Media
                                        className={"img-fluid for-light w-50"}
                                        src={`${require("../../assets/images/logo/logo.png")}`}
                                        alt={"logo image"}
                                    />
                                </div>
                                <div className='login-main'>
                                    <Formik
                                        initialValues={{
                                            first_name: "",
                                            last_name: "",
                                            email: "",
                                            password: "",
                                            confirm_password: "",
                                            agree_policy: false,
                                            "g-recaptcha-response":"",
                                        }}
                                        onSubmit={(values, {setSubmitting}) => signup(values, setSubmitting)}
                                    >
                                        {props => {
                                            const {handleSubmit, values,isSubmitting,touched} = props;
                                            return (
                                                <form onSubmit={handleSubmit} className="theme-form">
                                                    <h2 className={"text-center"}>{localized.CreateYourAccount}</h2>
                                                    <div>
                                                        <Row className='g-2'>
                                                            <Col className='col-6'>
                                                                <Field
                                                                    placeholder={localized.first_name}
                                                                    name="first_name"
                                                                    type="text"
                                                                    validate={required}
                                                                    label={localized.first_name}
                                                                />
                                                            </Col>
                                                            <Col className='col-6'>
                                                                <Field
                                                                    placeholder={localized.last_name}
                                                                    name="last_name"
                                                                    type="text"
                                                                    validate={required}
                                                                    label={localized.last_name}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <Field
                                                        label={localized.EmailAddress}
                                                        placeholder={localized.EmailAddress}
                                                        name="email"
                                                        type="email"
                                                        validate={emailvalidate}
                                                    />
                                                    <FormGroup className='form-group'>
                                                        <Label
                                                            className="col-form-label">{localized.Password}</Label>
                                                        <div className='form-input position-relative'>
                                                            <Field
                                                                name="password"
                                                                type={togglePassword ? 'text' : 'password'}
                                                                placeholder='*********'
                                                                validate={strongPassword}
                                                            />
                                                            <div className="show-hide"
                                                                 onClick={() => setTogglePassword(!togglePassword)}>
                                                                <span className={togglePassword ? "" : "show"}/>
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                    <FormGroup className='form-group'>
                                                        <Label
                                                            className="col-form-label">{localized.Confirm_Password}</Label>
                                                        <div className='form-input position-relative'>
                                                            <Field
                                                                name="confirm_password"
                                                                type={toggleCPassword ? 'text' : 'password'}
                                                                placeholder='*********'
                                                                validate={(value) => matchesPassword(value, values)}
                                                            />
                                                            <div className="show-hide"
                                                                 onClick={() => setCTogglePassword(!toggleCPassword)}>
                                                                <span className={toggleCPassword ? "" : "show"}/>
                                                            </div>
                                                        </div>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="focusAfterClose">{localized.Language}</Label>
                                                        <Input
                                                            type="select"
                                                            id="focusAfterClose"
                                                            onChange={changeLanguage}
                                                            value={localLanguage}
                                                        >
                                                            <option value="en">English</option>
                                                            <option value="fr">Français</option>
                                                        </Input>
                                                    </FormGroup>
                                                    <FormGroup className="form-group mb-0">
                                                        <div className="checkbox p-0">
                                                            <Field
                                                                name="agree_policy"
                                                                type="checkbox"
                                                                label={
                                                                    <>
                                                                        {localized.AgreeWith}
                                                                        <a className="ms-2" href="https://verif.email/cgv-gcu">
                                                                            {localized.PrivacyPolicy}
                                                                        </a>
                                                                    </>
                                                                }
                                                                validate={required}
                                                            />
                                                        </div>
                                                        <div>
                                                            <ReCAPTCHA
                                                                name="g-recaptcha-response"
                                                                ref={recaptchaRef}
                                                                sitekey="6LfQ2xclAAAAANTzWJZrcUFB_4OVFmrjy7eAEMmr"
                                                                onChange={(value)=>setCaptcha(value)}
                                                            />
                                                            <p className="captcha-design">{captcha === "" && touched["g-recaptcha-response"] ? localized.CaptchaRequired : ""}</p>
                                                        </div>
                                                        <div className='text-end mt-3'>
                                                            <Button
                                                                color={'primary w-100'}
                                                                type="submit"
                                                                className={'btn-block'}
                                                                disabled={isSubmitting}
                                                            >{isSubmitting ? localized.CreatingAccount : localized.CreateAccount}
                                                            </Button>
                                                        </div>
                                                    </FormGroup>
                                                </form>
                                            )
                                        }}
                                    </Formik>
                                    <p className="mt-4 mb-0 text-center">
                                        {localized.Already_have_an_account}?
                                        <Link className="ms-2" to={`/login${getParams("lang") ? "?lang=" + getParams("lang") : ""}`}>
                                            {localized.Login}
                                        </Link>
                                    </p>
                                </div>
                            </div>
                        </Fragment>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default SignUp;